import type { FC } from "react";
import categoryService from "app/common/services/categoryService";
import { getCategoryDetailsForDashboard } from "app/pages/industry-analysis/category-share/CategoryShareGraph/utils/CategoryShareGraphUtils";
import type {
    ICategoryLeadersNavParams } from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";
import {
    ECategoryLeadersMetricType,
} from "app/pages/industry-analysis/category-leaders/CategoryLeaders.types";
import type { ICategoryLeadersTableQueryParams } from "../../CategoryLeadersTable.shared.types";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";

interface IAddToDashboardProps {
    filtersStateObject: ICategoryLeadersTableQueryParams;
    navParams: ICategoryLeadersNavParams;
    tableFilters: string;
    metricType: ECategoryLeadersMetricType;
}

export const AddToDashboardWrapper: FC<IAddToDashboardProps> = ({
    filtersStateObject,
    navParams,
    tableFilters,
    metricType,
}) => {
    const { category } = navParams;

    const overrideAddToDashboardParams = {
        ...filtersStateObject,
        key: [getCategoryDetailsForDashboard({ category }, { categoryService })],
        family: "Industry",
        duration: "1m",
    };

    return (
        <AddToDashboard
            modelType="fromIndustry"
            webSource={navParams.webSource as IWidgetModelTypesWebSource}
            type="LeaderBySourceTable"
            metric={ECategoryLeadersMetricType[metricType]}
            filters={tableFilters ? { filter: tableFilters } : {}}
            overrideAddToDashboardParams={overrideAddToDashboardParams}
            industryQueryParams={navParams.category}
        />
    );
};
